/**
 * Fake mobile numbers for signing in on staging without a handset. The API skips the SMS and
 * takes 000000 as the code - see secret-spa-api src/utils/sms/testNumbers.ts, which matches the
 * same range. It has to be +990: the rest of +99 is real countries, +992 to +996 and +998.
 */

export const TEST_MOBILE_DIAL_CODE = '+990'
export const TEST_MOBILE_CODE = '000000'

// +990 followed by 5-11 digits
const TEST_MOBILE = /^\+990\d{5,11}$/

// The API only honours test numbers outside production
export const testMobilesEnabled = (environment?: string): boolean =>
  environment === 'development' || environment === 'staging'

export const isTestMobile = (environment: string | undefined, mobile: string): boolean =>
  testMobilesEnabled(environment) && TEST_MOBILE.test(mobile.replace(/\s/g, ''))

const TEST_MOBILE_PARTIAL = /^\+990\d{0,4}$/

export const isTestMobileIncomplete = (environment: string | undefined, mobile: string): boolean =>
  testMobilesEnabled(environment) && TEST_MOBILE_PARTIAL.test(mobile.replace(/\s/g, ''))
